import React, { useState, useEffect } from "react";
import { DataProvider } from "./Data";
import Navbar from "./components/Custom/navbar/Navbar";
import Carousel from "./components/Custom/carousel/Carousel";
import Careers from "./components/Custom/careers/Careers";
import About from "./components/Custom/About/About";
import Contact from "./components/Custom/Contact/Contact";
import Receiver from "./components/Custom/projects/Receiver";
import AdminPage, { ALLOWED_EMAILS } from "./components/Admin/AdminPage";
import { signInWithPopup, signOut } from "firebase/auth";
import { auth, googleProvider } from "./firebase";
import { v4 as uuidv4 } from "uuid";
import SpinUp from "./components/SpinUp/SpinUp";

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  useHistory,
  useLocation,
} from "react-router-dom";
import "./App.css";

function AdminKeyTrigger() {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    let buffer = "";
    let timeout = null;

    const handleKeyDown = async (e) => {
      // Trigger only when on the homepage
      if (location.pathname !== "/") return;

      // Do not trigger if typing inside form inputs
      if (["INPUT", "TEXTAREA"].includes(document.activeElement?.tagName)) return;

      if (e.key && e.key.length === 1) {
        buffer += e.key.toLowerCase();
        if (buffer.length > 10) {
          buffer = buffer.slice(-10);
        }

        if (buffer.endsWith("admin")) {
          buffer = "";
          try {
            const result = await signInWithPopup(auth, googleProvider);
            const email = result.user?.email?.toLowerCase();
            if (ALLOWED_EMAILS.includes(email)) {
              history.push("/admin");
            } else {
              await signOut(auth);
              alert(
                `Access denied: "${result.user?.email}" is not an authorized administrator.`
              );
            }
          } catch (err) {
            if (err.code !== "auth/popup-closed-by-user") {
              console.error("Admin sign-in error:", err);
            }
          }
        }

        clearTimeout(timeout);
        timeout = setTimeout(() => {
          buffer = "";
        }, 3000);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      clearTimeout(timeout);
    };
  }, [history, location.pathname]);

  return null;
}

function AdminPreviewSync() {
  const history = useHistory();
  const location = useLocation();
  const isIframe = typeof window !== "undefined" && window.self !== window.top;

  useEffect(() => {
    // Only run sync inside an embedded preview iframe
    if (!isIframe) return;

    // Never allow iframe to stay on /admin (prevents recursive tree opening)
    if (location.pathname === "/admin" || location.pathname.startsWith("/admin")) {
      history.replace("/projects");
      return;
    }

    try {
      window.parent.postMessage(
        { type: "PREVIEW_URL_CHANGED", url: location.pathname },
        "*"
      );
    } catch (e) {}
  }, [location.pathname, isIframe, history]);

  useEffect(() => {
    // Only listen for preview navigation commands if we are inside the preview iframe
    if (!isIframe) return;

    let bc;
    const handleNav = (targetUrl) => {
      if (!targetUrl) return;
      // Never navigate the preview iframe to /admin
      if (targetUrl === "/admin" || targetUrl.startsWith("/admin")) return;

      const curPath = decodeURIComponent(location.pathname).replace(/\/$/, "");
      const newPath = decodeURIComponent(targetUrl).replace(/\/$/, "");
      if (curPath !== newPath) {
        history.push(targetUrl);
      }
    };

    try {
      bc = new BroadcastChannel("lwong_live_preview");
      bc.onmessage = (event) => {
        if (event.data?.type === "NAVIGATE_PREVIEW" && event.data.url) {
          handleNav(event.data.url);
        } else if (event.data?.type === "LIVE_UPDATE" && event.data.previewUrl) {
          handleNav(event.data.previewUrl);
        }
      };
    } catch (e) {}

    const handleMsg = (event) => {
      if (event.source === window) return;
      if (event.data?.type === "NAVIGATE_PREVIEW" && event.data.url) {
        handleNav(event.data.url);
      } else if (event.data?.type === "LIVE_UPDATE" && event.data.previewUrl) {
        handleNav(event.data.previewUrl);
      }
    };
    window.addEventListener("message", handleMsg);

    return () => {
      if (bc) bc.close();
      window.removeEventListener("message", handleMsg);
    };
  }, [history, location.pathname, isIframe]);

  return null;
}

function SpinUpWrapper() {
  const location = useLocation();
  if (location.pathname === "/admin") return null;
  return <SpinUp />;
}

function App() {
  const [navbar, setNavbar] = useState(false);

  const dispId = uuidv4;
  const isIframe = typeof window !== "undefined" && window.self !== window.top;

  return (
    <div>
      <div>
        <DataProvider>
          {/* <ProjectsMini /> */}
          <Router>
            <AdminPreviewSync />
            <AdminKeyTrigger />
            <Navbar dispId={dispId} setNavbar={setNavbar} />
            <Switch>
              <Route path="/about">
                <About />
              </Route>
              <Route exact path={["/"]}>
                <Carousel />
              </Route>
              <Route path="/projects">
                <Receiver dispId={dispId} navbar={navbar} />
                {/* This has classes from projects */}
              </Route>
              <Route path="/Careers">
                <Careers />
              </Route>
              <Route path="/Contact">
                <Contact />
              </Route>
              <Route path="/admin">
                {isIframe ? <Redirect to="/projects" /> : <AdminPage />}
              </Route>
              {/* <Route path="/people">
              <People />
            </Route> */}
            </Switch>
            <SpinUpWrapper />
          </Router>

          {/* <Model></Model> */}
        </DataProvider>
      </div>
    </div>
  );
}

// notes:
// calss block is abit confusing, people think they can click a specific project
// client recommend title persists on hover

// project on back should go back to specific class type

// lock the nav bar

export default App;
